export const environment = {
    production: true,
    debug: false,
    apiUrl: '/api',
    pdfUrl: 'https://prm.volkerwessels.app/api',//'https://prm.volkerwessels.app/api',
    applicationInsights: {
        instrumentationKey: 'c3e53766-3c4d-4d33-881d-a70266eab2c5'//'341f28c1-9525-4b87-94a2-bb5500cf4b82' //  hosted @ BVGO, resource group BVGO-WE-RSG-AP-PRM
    },
    msAuth: {
        issuer: 'https://login.microsoftonline.com/common/v2.0',
        clientId: '56fa14aa-b9b6-4ca3-831a-085c9643d8a8',//'4f58e689-a35d-4737-851d-fa167ff1e04d',
        redirectUri: `${window.location.origin}/msal-auth`,
        scopes: ['api://56fa14aa-b9b6-4ca3-831a-085c9643d8a8/user.read'],
        redirectToExternalEndSessionEndpointAfterLogout: false,
        redirectRoute: {
            afterAuthentication: ['/'],
            noAuthentication: ['/no-access'],
            failedAuthentication: ['/error']
        },
        // Use LocalStorage to allow same authentication across multiple browser tabs and persistence of tokens
        sessionStorageDriver: localStorage
    },
    features: {
        accessibleSteps: {
            enabled: false,
            showSetToDefaultButton: false // Useful for testing / debugging
        },
        apiProjectCreation: {
            enabled: true
        },
        pitFeature: {
            enabled: false
        }
    }
};
